import { ApiProperty } from '@nestjs/swagger';
import { IsArray, IsUUID } from 'class-validator';

export class SetSucursalesRubroDto {
  @ApiProperty({
    type: [String],
    description: 'Set completo de sucursales del rubro. Reemplaza lo anterior; vacío deja el rubro sin sucursales.',
  })
  @IsArray()
  @IsUUID('4', { each: true })
  sucursal_ids: string[];
}
